import React, { useEffect, useState } from 'react';
import './UpdateBanner.css';

/**
 * A phone can keep running an old copy of the app for days (home-screen apps rarely restart).
 * Whenever the app comes back to the front, check whether a newer version is live and offer it.
 * Never reloads by itself — an agent mid-inspection taps when ready (drafts are saved either way).
 */
const currentBundle = () => {
  const s = [...document.scripts].map((x) => x.src).find((src) => /\/static\/js\/main\.[\w]+\.js/.test(src));
  return s ? s.match(/main\.([\w]+)\.js/)[1] : null;
};

const UpdateBanner = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return undefined; // local dev
    const check = async () => {
      if (document.visibilityState !== 'visible') return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: 'no-store' })).text();
        const live = (html.match(/main\.([\w]+)\.js/) || [])[1];
        if (live && live !== mine) setReady(true);
      } catch {
        /* no signal — check again next time */
      }
    };
    check();
    document.addEventListener('visibilitychange', check);
    const t = setInterval(check, 10 * 60 * 1000);
    return () => {
      document.removeEventListener('visibilitychange', check);
      clearInterval(t);
    };
  }, []);

  if (!ready) return null;
  return (
    <button type="button" className="update-banner" onClick={() => window.location.reload()}>
      New version available — tap to update
    </button>
  );
};

export default UpdateBanner;
